module.exports = __webpack_public_path__ + "img/baf6b6037544536e72b6fe628bee3386.png";